<div fxLayout="column" fxLayoutGap="12px">
  <h2>Connect your Stripe account</h2>

  <span>
    To process payouts to your Stripe account, we need you to connect via OAuth. This will allow us to collect payments
    from your guests which go directly to your Stripe account.
  </span>

  <div fxLayoutAlign="end center">
    <sbnb-button style="margin-top: 24px" label="Connect to Stripe" (click)="startStripeOauth()"></sbnb-button>
  </div>
</div>
